import React from "react";

import {
  useGetWorkflowMetricsOverviewQuery,
  usePutWorkflowsFindFilterQuery,
} from "../../app/useGeneratedApi";
import {
  mapToWorkflowStatuses,
  metricMapper,
  workflowsNav,
} from "./WorkflowsPage.helpers";
import { useConfigView } from "../../Config.context";

export function useWorkflowsPage() {
  const [activeNavItem, setActiveNavItem] = React.useState("All");
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);
  const { config } = useConfigView();

  const onNavChange = (value: string) => {
    setActiveNavItem(value);
  };

  const {
    data: workflowMetricsOverviewData,
    refetch: refetchOverviewMetrics,
    isLoading: isWorkflowMetricsOVerviewLoading,
  } = useGetWorkflowMetricsOverviewQuery({
    enabled: config?.shopifyIntegration,
  });

  const workflowStatuses = React.useMemo(
    () => mapToWorkflowStatuses(activeNavItem),
    [activeNavItem]
  );

  const { data, isLoading: isWorkflowsLoading } =
    usePutWorkflowsFindFilterQuery(
      {},
      {},
      {
        keepPreviousData: true,
      }
    );

  const numberOfWorkflows = data?.totalElements || 0;

  const nav =
    numberOfWorkflows >= 1
      ? workflowsNav
      : isWorkflowsLoading
      ? [workflowsNav[0]]
      : undefined;

  const tabValue = nav
    ? nav.findIndex((item) => item.name === activeNavItem)
    : 0;

  const changeTab = (value: number) => {
    if (nav) {
      onNavChange(nav[value].name);
    }
  };

  const handleOpenMenu = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const handleCloseMenu = () => {
    setAnchorEl(null);
  };

  const mappedWorkflowMetrics = metricMapper(
    workflowMetricsOverviewData,
    config?.currency || ""
  );

  return {
    nav,
    tabValue,
    changeTab,
    activeNavItem,
    isWorkflowsLoading,
    onNavChange,
    workflowStatuses,
    numberOfWorkflows,
    anchorEl,
    setAnchorEl,
    handleOpenMenu,
    handleCloseMenu,
    open,
    mappedWorkflowMetrics,
    isWorkflowMetricsOVerviewLoading,
  };
}
